import axios from "axios";
import { api_base_url } from "../config/api";
import Cookie from "js-cookie";
import { toast } from "react-toastify";
import { retryAfterWake, shouldAttemptWake } from "./wakeBackend";

// axios.defaults.withCredentials = true;

class HttpService {
  config(config, endpoint) {
    config.timeout = 0;
    const role = Cookie.get("role");
    let token = null;

    if (role === "leads") {
      token = Cookie.get("token_leads");
    } else if (role === "user") {
      token = Cookie.get("token_user");
    }

    if (!endpoint.includes("http://") && !endpoint.includes("https://"))
      config.baseURL = api_base_url;

    if (!config.headers) config.headers = {};

    if (
      token &&
      !config.headers.Authorization &&
      !endpoint.includes("http://") &&
      !endpoint.includes("https://")
    ) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  }

  /** Created this method handler for error to process necessary steps before returning reject response of the promise. */
  errorhandler(errorData) {
    if (errorData?.response?.status === 401) {
      toast.error("Session Expired! Please login again.", {
        toastId: "session-expired",
      });
      setTimeout(() => {
        Object.keys(Cookie.get()).map(function (cookieName) {
          Cookie.remove(cookieName);
        });
        window.location.replace("/");
      }, 1000);
      return errorData;
    }
    /**
     * The following cases are the reason why this handler is created
     * - Refreshing expired tokens.
     */
    return errorData;
  }

  async request(method, endpoint, dataOrParams, config = { headers: {} }, { isGetOrDelete = false } = {}) {
    if (isGetOrDelete) {
      config.params = dataOrParams;
    }
    config = await this.config(config, endpoint);

    const axiosConfig = {
      ...config,
      method,
      url: endpoint,
    };
    if (!isGetOrDelete) {
      axiosConfig.data = dataOrParams;
    }

    try {
      return await axios.request(axiosConfig);
    } catch (err) {
      if (!axiosConfig.__wakeRetried && shouldAttemptWake(err, axiosConfig)) {
        try {
          return await retryAfterWake(axios, axiosConfig);
        } catch (wakeErr) {
          throw this.errorhandler(wakeErr);
        }
      }
      throw this.errorhandler(err);
    }
  }

  get(endpoint, params, config = { headers: {} }) {
    return this.request("get", endpoint, params, config, { isGetOrDelete: true });
  }

  post(endpoint, params, config = { headers: {} }) {
    return this.request("post", endpoint, params, config);
  }

  put(endpoint, params, config = { headers: {} }) {
    return this.request("put", endpoint, params, config);
  }

  patch(endpoint, params, config = { headers: {} }) {
    return this.request("patch", endpoint, params, config);
  }

  delete(endpoint, params, config = { headers: {} }) {
    return this.request("delete", endpoint, params, config, { isGetOrDelete: true });
  }
}

export default new HttpService();
